// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"152":"b9573ec9","347":"dd8358c9","494":"5dfe0ef7","523":"cfb087bd","570":"e7d42cb2","714":"bda5eda2","946":"d76258fa"}[chunkId] + ".chunk.js";
};